import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_PREBID_MODULE: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspacePrebidModule($id: ID!) {
    node(id: $id) {
      ... on WorkspacePrebidModule {
        id
        params
        enabled
        status

        prebidModule {
          id
          name
          demand
        }
      }
    }
  }
`
